
























































































































































import CardHeader from "@/components/CardHeader.vue";
import {BasicMixin} from "@/mixins/AdminMixin"
import {ActivityClassInterface, EnumType, ActivitySubCategoryInterface} from "@/models/Activity"
import { CATEGORY} from "@/plugins/Config"
import {db} from "@/plugins/db";

import {Component, Mixins} from 'vue-property-decorator'
import {mapState} from "vuex";
import * as firebase from "firebase";

@Component({
    components:{
        CardHeader
    },
    computed:{
        ...mapState({
            ActivityCategory:(state: any) => state.activity.ActivityCategory,
            clases:(state: any) => state.activity.clases,
        })
    }
})
export default class Activity extends Mixins(BasicMixin) {

    public formImage: any = null;
    public formImageUrlPreview = '';
    public uploadValue = 0;


   public Clase: ActivityClassInterface = {
       subCategory:{
           id:'',
           title: '',
           category: {
               title:''
           }
       },
       type: EnumType.ADULTOS
   };

   public categories = CATEGORY;

   public subCategories: ActivitySubCategoryInterface[] = [];
    Category = '';

    public headers: any[] = [
        {
            text: 'Tipo',
            align: 'left',
            sortable: true,
            value: 'type',
        },
        {
            text: 'Categoria',
            align: 'left',
            sortable: true,
            value: 'category',
        },
        {
            text: 'Sub-categoria',
            align: 'left',
            sortable: true,
            value: 'subcategory',
        },
        {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'createdAt',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public subCategoryData: ActivitySubCategoryInterface = {
        id:'',
        title: '',
        category: {
            title:''
        }
    };


    openModal(edit: boolean, item: ActivityClassInterface | any){
        this.edit = edit;
        this.dialog = true;
        if (edit){
            this.idModel = item.id;
            this.Clase  = {
                id: item.id,
                subCategory: item.subCategory,
                type: item.type,
                background: item.background
            };
        }else {
            this.Clase  = {
                subCategory:{
                    title: '', category: {
                        title:''
                    }
                },
                type: EnumType.ADULTOS
            };
        }
    }

    async getSubcategories(){
        try {
            const subCategories = await db.collection('ActivitySubCategory').where('category.id', '==', this.Category).get();
            if (subCategories){
                this.Clase.subCategory = {
                    title: '', category: {
                        title:''
                    }
                };
                this.subCategories = [];
                subCategories.forEach((doc: any) => {
                    this.subCategories.push(doc.data())
                })
            }
        }catch (e) {
            alert(e)
        }
    }

    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.Clase, collection: 'clases'});
            this.text = 'Se ha editado la clase';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createClases', this.Clase);
            this.text = 'Se ha editado la clase';
            this.dialog = false;
            this.snackbar = true;
        }
    }

    chang(e: any){
        this.subCategoryData = e
    }

    addId(){
        this.Clase.subCategory = {
            id:'',
            title: '',
            category: {
                    title:''
                }
        };
        this.Clase.subCategory.id = this.subCategoryData.id;
        this.Clase.subCategory.title = this.subCategoryData.title;
        this.Clase.subCategory.createdAt = this.subCategoryData.createdAt;
        this.Clase.subCategory.category = this.subCategoryData.category;
    }
    get adultosCount(){
        return this.$store.getters.claseAductos.length

    }
    get niñosCount(){
        return this.$store.getters.claseNiños.length

    }

    deleteItem(item: any){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'clases'})

    }
    
    previewImage(event: any) {
        this.formImage = event
        this.formImageUrlPreview = URL.createObjectURL(event);
    }

    uploadFile(){
        const storageRef= firebase.storage().ref(`clases/${new Date().getTime()}_${this.formImage.name}`).put(this.formImage);
        storageRef.on(`state_changed`,snapshot=>{
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{alert(error.message)},
            ()=>{this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.Clase.background = url;
                });
            }
        );
    }




}
